module.exports = __webpack_public_path__ + "static/media/omelette.fe2fa015.mov";


//////////////////
// WEBPACK FOOTER
// ./src/images/2020-06-06/omelette.mov
// module id = 831
// module chunks = 0